import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EsItemList from '../../components/es/EsItemList';
import { reqEsItemListAction, resetItemStatus, reqEsItemListIngAction } from '../../modules/es/esItemModule';
import styled from 'styled-components';
import CheckBtn from '../../components/common/button/CheckBtn';
import {isMobileOnly} from 'react-device-detect';
import { groupBy, forEach, remove, concat, findIndex, replace } from 'lodash';
import { useHistory } from 'react-router-dom';

const EstimateListHeaderBlock = styled.div`
    ${isMobileOnly?`
    //margin: 0 4vw; 
    background: #ffffff; 
    margin-bottom: 20px;
    `:`
    margin-bottom: 10px;
    `};
    height: 60px;
    padding: 17px 0px;
    
`;

const EstimateListHeaderCheckBlock = styled.div`
    ${isMobileOnly?`
    margin-left: 4vw; 
    `:`
    
    `};
    float : left;
    margin-top: -4px;
`;
const EstimateListHeaderSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 14px;
    line-height: 26px;   
    `:`
    font-size: 16px;
    `};
    float : left;
    margin-left : 10px;
    
    font-weight: normal;
    text-align: left;
    color: #333333;
`;

const EstimateListHeaderHiddenBlock = styled.div`
    ${isMobileOnly?`
    //margin: 0 4vw; 
    height: 6px;
    background: #ffffff; 
    margin-bottom: 20px;
    `:`
    margin-bottom: 10px;
    `};
    
`;

const EsItemsListContainer = ({ curIdx, handleIngAllCheckClick, handlleIngCheckClick }) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [useAll, setUseAll] = useState(false);

    const { esListResult, esItems, error, loading, accessToken, esItemCheck } = useSelector(
        ({ esItemsReducer, loadingReducer, userReducer }) => ({
            esListResult: esItemsReducer.esListResult,
            esItems: esItemsReducer.esItems,
            error: esItemsReducer.error,
            loading: loadingReducer['esitem/LIST_ES_ING'],
            accessToken: userReducer.accessToken,
            esItemCheck: esItemsReducer.esItemCheck,
        })
    );

    useEffect(() => {
        if (accessToken !== null) {
            //dispatch(reqEsItemListAction("type=0&sort=0"));
            //console.log("history = " + JSON.stringify(history))
            if(history.action !== 'POP' || esItems === null){
                dispatch(reqEsItemListIngAction());
            } 
        }

    }, []);

    useEffect(() => {
        if (accessToken !== null && esListResult === null) {
            //dispatch(reqEsItemListAction("type=0&sort=0"));
            dispatch(reqEsItemListIngAction());
        } else if (esListResult === 600) {
            dispatch(resetItemStatus());
        }

    }, [accessToken, esListResult]);

    useEffect(() => {
        if(esItems === null || esItems === undefined || esItems.length < 1) {
            setUseAll(false);
            return;
        }
        let countCom = 0;
        forEach(esItems, (curobjs, index) => {
            let curobj = curobjs[0];
            if(curobj.rqst_status==="050105"){
                countCom++;
                setUseAll(true);
            }

        });

        if(countCom > 0) {
            setUseAll(true);
        } else {
            setUseAll(false);
        }

    }, [esItems]);

    // 체크 상태 확인
    const getCheckStatus = () => {
        let ret = true;

        if(esItems === null || esItems === undefined || esItems.length < 1) {
            return false;
        }

        forEach(esItems, (curobjs, index) => {
            let curobj = curobjs[0];
            if(curobj.rqst_status==="050105"){
                
                let idx = findIndex(esItemCheck, (curitem) => {
                    return (curitem.es_rqst_id === curobj.es_rqst_id);
                })
                //console.log("esItemCheck = " + JSON.stringify(esItemCheck))
                if (idx < 0) {
                    ret = false;
                }
            }

        });

        return ret;
    }

    if(esItems === null || esItems === undefined) {
        return <div></div>;
    } 
    
    const getHiddenHeader = () => {
        if(esItems === null || esItems === undefined || esItems.length < 1) {
            return true;
        }

        if(!useAll) {
            return true;
        }

        return false;
    }

    return (
    <div>
        <EstimateListHeaderBlock style={getHiddenHeader()? {display:'none'}:{display:'block'}} >
                <EstimateListHeaderCheckBlock>
                <CheckBtn onClick={handleIngAllCheckClick} defaultValue={getCheckStatus()}/>
            </EstimateListHeaderCheckBlock>
            <EstimateListHeaderSpanBlock>모두선택</EstimateListHeaderSpanBlock>
        </EstimateListHeaderBlock>
        <EstimateListHeaderHiddenBlock style={getHiddenHeader() === false ? {display:'none'}:{display:'block'}} />
                
        <EsItemList
        loading={loading}
        accessToken={accessToken}
        esItems={esItems}
        curIdx={curIdx}
        handlleIngCheckClick = {handlleIngCheckClick}
        />
    </div>
        

    )

}

export default EsItemsListContainer;